import React from 'react';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import { LinearProgress } from 'material-ui/Progress';
import OLYWebPageComponent from '../OLYWebPageComponent';
import DynIcon from '../Utils/DynIcon';
import { translate } from 'react-i18next';
import { Typography, withStyles, TextField } from '../../../node_modules/material-ui';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';

import { generateTokenService } from './tokenGeneratorService';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    },
    FormControl: {
        display: 'flex',
        width: '400px',
        margin: '1.5rem 0 0 0'        
    }
});
class TokenGeneratorView extends OLYWebPageComponent {
    constructor(props) {
        super(props, 'TokenGeneratorView');
        this.pageName = 'TokenGeneratorView';
        this.state = {
            loading: false,
            gottoken: false,
            copied: false,
            username: '',
            password: ''
        };
    }

    generateToken = () => {
        this.setState({ loading: true });
        generateTokenService(this.state.username, this.state.password)
            .then(result => {
                this.setState({
                    gottoken: true,
                    token: result.token
                });
            }).catch(error => {
                //Esto ya lo traduce el backend
                this.setState({
                    gottoken: false,
                });
                alert(error.message);
            })
            .finally(res => {
                this.setState({ loading: false, copied: false });
            });
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className="cmsTokenGenerator">
                <div>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <Paper style={{ margin: 15, padding: 20 }}>
                    <Typography className={classes.tableTitle}>
                        <DynIcon icon="VpnKey" style={{ width: 32, height: 32, float: 'left' }} />
                        <strong style={{ paddingLeft: 8 }}>{t('PAGE_TITLES.' + this.pageName)}</strong>
                    </Typography>
                    <div style={{ paddingLeft: 38 , margin:'0 0 3rem 0' }} >  
                    <p>{t('TokenGeneratorView.INTRO_TEXT')}</p>
                    <Typography style={{ maxWidth: '395px' }}>{t('TokenGeneratorView.LEYEND')}</Typography>                                     
                    <FormControl className={classes.FormControl} component="fieldset">
                        <TextField
                            id="username"
                            label={t('COMMON.USER')}
                            required={true}
                            onChange={event => {
                                this.setState({
                                    username: String(event.target.value),
                                    gottoken: false,
                                    copied: false
                                });
                            }}
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        <DynIcon icon="AccountCircle" />
                                    </InputAdornment>
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            helperText={t('RECOVER_PASSWORD.PLEASE_ENTER_USER')}
                        /> 
                    </FormControl>
                    <FormControl className={classes.FormControl} component="fieldset">
                        <TextField
                            id="password"
                            label={t('LOGIN.PASSWORD')}
                            required={true}
                            onChange={event => {
                                this.setState({
                                    password: String(event.target.value),
                                    gottoken: false,
                                    copied: false
                                });
                            }}
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        <DynIcon icon="VpnKey" />
                                    </InputAdornment>
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            placeholder={t('LOGIN.ENTER_USER_PASSWORD')}
                            helperText={t('RECOVER_PASSWORD.PASSWORD_VALIDATION_PATTERN')}
                        />
                        </FormControl>
                        <FormControl className={classes.FormControl} component="fieldset">
                        <Button 
                            style={{color:'var(--secondary-button--text-color)', backgroundColor: 'var(--secondary-button-color)', height: '3rem'}}
                            variant="raised" color="secondary"
                            disabled={this.state.loading}
                            onClick={() => this.generateToken()}>{t('TokenGeneratorView.GENERATE_BUTTON')}</Button>
                        </FormControl>
                        <FormControl className={classes.FormControl} component="fieldset">
                        <CopyToClipboard text={this.state.token}
                            onCopy={() => this.setState({ copied: true })}>
                            <Button variant="raised" disabled={!this.state.gottoken}
                                color="primary">
                                <DynIcon icon="VpnKey" style={{ width: 32, height: 32, float: 'left', margin: '0 0.5rem 0 0', fill: 'white !important', color:'white !important' }} />
                                {t('TokenGeneratorView.COPY_TOKEN_BUTTON')}
                            </Button>
                        </CopyToClipboard>
                        </FormControl>
                        {this.state.copied ? <span style={{ color: 'red' }}>{t('TokenGeneratorView.COPY_SUCCESS')}</span> : null} 
                        </div>                   
                </Paper>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(TokenGeneratorView));


// WEBPACK FOOTER //
// ./src/components/BackOffice/TokenGeneratorView.js